import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
import { isEmpty } from 'rxjs/operator/isEmpty';

const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'process'

  }
];

@Component({
  selector: 'page-process',
  templateUrl: './process.html',
  styleUrls: ['./process.scss']
})

export class PageProcess implements OnInit {
  //initial & Search
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  loadingIndicator: boolean = true;
  key:any="";
  processs = [];

  //autoincreate
  filtered:any;
  ctrl:FormControl;
  items = [];
  //form
  form: FormGroup;selectedCtrl = new FormControl();selectedProductCtrl = new FormControl();
  machines = [];arr_machine=[];arr_product=[];products=[];
  selected:any;controlCheck:any=0;selected_product:any;
  code:string;name:string;vender:string;ct:string;detail:string;id:string;
  ckedit:boolean=false;
  //upload
  fileupload:string;
  fileupload_:string;
  //data table
  data:any;
  rows = [];temp=[];
  picture:String=null;
  //upload file
  imageSrc:any;
  imageSrc_:any;
  urlApi=environment.url+"/api/uploadToserver.php";
  urlApi_=environment.url+"/api/uploadToserver_check_sheet.php";
  sysPath:String=environment.sysPath;
  Name:string;controlPoint:string;
  myFile:File; /* property of File type */
  myFile_:File; /* property of File type */
  //dialog
  dialogRefWarning: MdDialogRef<WarningProcessDialog>;
  dialogRef: MdDialogRef<processDialog>;
  setId:any;
  sysPathPrint:String=environment.sysPath+"/api/process-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/process-list-export.php";


  dropdownListMachine = [];
  selectedItemsMachine = [];
  selectedItemsPartno = [];
  dropdownListPartno = [];
  //dropdownSettings = {};
  dropdownSettings = { 
    singleSelection: false, 
    text:"Select",
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    classes:"col-md-12"
  };  

  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    this.getSearchProcess();
    this.getMachine();
    this.getStartData();
    this.getProduct();





    //this.setId = this.intervalGetData();
   // console.log('-------this.filteredStates-----',this.filteredStates);
    this._sharedService.emitChange(this.pageTitle);
  }
onItemSelect(item:any){}
OnItemDeSelect(item:any){}
onSelectAll(items: any){}
onDeSelectAll(items: any){}

  intervalGetData(){
    
    return setInterval(() => {
      if(this.setId.runCount>5){
        clearInterval(this.setId);
        }
      this.getStartData();
      console.log('------this.setId------',this.setId);
     }, 1000);

  }
  getProduct(){
    this.httpservice.fetchget('getJSON_product.php?',(data)=>{
     // this.products = data;

      for(let i = 0;i<data.length;i++){
        this.dropdownListPartno.push({"id":data[i].tp_id,"itemName":data[i].tp_part_no});
      }
    });
  }

  getStartData(){
    this.httpservice.fetchget('getJSON_process.php?',(process) => {
      this.rows = process;
      this.temp = process;
      this.loadingIndicator = false;
      console.log('------this.machine------', this.key,process,this.rows);
    });
  }

  getMachine(){
    this.httpservice.fetchget('getJSON_machine.php?',(data)=>{
      this.machines = data;

      for(let i = 0;i<data.length;i++){
        this.dropdownListMachine.push({"id":data[i].tma_id,"itemName":data[i].tma_code+'-'+data[i].tma_name});
      }
      
      //console.log('dropdownlist',this.dropdownListMachine);

    });
  }

  getSearchProcess(){
    this.httpservice.fetchget('getJSON_process_name.php?',(process) => {
      this.processs = process.map(function (val) {
        return [val.tpn_name];
      });
      console.log('------this.machine------', this.processs);
    });
    this.ctrl = new FormControl();
    this.filtered = this.ctrl.valueChanges
    .startWith(null)
    .map(val => {
      if (isArray(val)) {
        this.key = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.key = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.processs.filter((s) => new RegExp(val, 'gi').test(s)) : this.processs;
    });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('deleteProcess.php', val, (cb) => {});
  this.getStartData();
  }

  setedit(id:string){
    this.cancelEdit();
    this.id = id;
    this.ckedit=true;
    this.httpservice.fetchget('getJSON_process.php?id='+id,(process) => {
      this.form.controls.code.setValue(process[0].tpn_code);
      this.form.controls.name.setValue(process[0].tpn_name);
      this.form.controls.ct.setValue(process[0].tpn_ct);
      this.form.controls.detail.setValue(process[0].tpn_detail);
      this.controlCheck = Number(process[0].tpn_control);
     // this.picture = process[0].tpn_point_picture;
    

      if(process[0].tpn_point_picture.length>0){
        this.picture = this.sysPath+'/picture/checkpoint/'+process[0].tpn_point_picture;
      }else{
        this.picture = this.sysPath+'/picture/no_image.jpg';
      }
      
      //this.user_selected.setValue("77");
      //this.selected=process[0].machine;
      //this.selected_product=process[0].product;
      this.selectedItemsMachine = process[0].machinem;
      this.selectedItemsPartno = process[0].productm;
    });
  }

  edit(){
    this.setId = this.intervalGetData();
    if (this.myFile != null) {
      this.fileupload = this.myFile.name;
    } else {
      this.fileupload = "";
    }

    if (this.myFile_ != null) {
      this.fileupload_ = this.myFile_.name;
    } else {
      this.fileupload_ = "";
    }

    this.ckedit = false;
    this.data = {
      id:this.id,
      code:this.form.controls.code.value,
      name:this.form.controls.name.value,
      detail:this.form.controls.detail.value,
      ct:this.form.controls.ct.value,
      filename:this.fileupload,
      filename_:this.fileupload_,
      control:this.controlCheck,
      machine:this.selectedItemsMachine,
      product:this.selectedItemsPartno
 
    }
    // insert data
    this.httpservice.fetchpost('editDataProcess.php', this.data, (cb) => {});

      //upload image
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }

      //upload image
      if (this.myFile_ != null) {
        this.uploadPhoto_(this.myFile_);
      }

  
    this.getStartData();
    console.log('------edit ------');
    this.selectedCtrl.reset();
    this.selectedProductCtrl.reset();
    this.selectedItemsPartno = [];
    this.selectedItemsMachine = [];
    this.form.reset();
    this.picture = null;
    this.controlCheck = false;
    this.arr_machine=[];

  }

  cancelEdit(){
    this.ckedit = false;
    this.selectedCtrl.reset();
    this.selectedProductCtrl.reset();
    this.selectedItemsPartno = [];
    this.selectedItemsMachine = [];
    this.form.reset();
    this.controlCheck = false;
    this.arr_machine=[];
    this.picture=null;

  }
  getProductInfo(val:string,_event: any,index:any){
    if(_event.isUserInput){
      if(_event.source.selected==true){
        this.arr_product.push(val);
       
      }else{
        this.arr_product.splice(index, 1);
       
      }
    }
  }

  getInfo(val:string,_event: any,index:any){

    if(_event.isUserInput){
    if(_event.source.selected==true){
      this.arr_machine.push(val);
      //console.log('true',_event.source.selected,_event,this.user_selected.value);
    }else{
      this.arr_machine.splice(index, 1);
      ///console.log('false',_event.source.selected,_event,this.user_selected.value);
    }

    console.log('arr_machine',_event);
  }
  }



save(){
  this.setId = this.intervalGetData();
  if (this.myFile != null) {
    this.fileupload = this.myFile.name;
  } else {
    this.fileupload = "";
  }

  if (this.myFile_ != null) {
    this.fileupload_ = this.myFile_.name;
  } else {
    this.fileupload_ = "";
  }


  this.data = {
    code:this.form.controls.code.value,
    name:this.form.controls.name.value,
    detail:this.form.controls.detail.value,
    ct:this.form.controls.ct.value,
    control:this.controlCheck,
    filename:this.fileupload,
    filename_:this.fileupload_,
    machine:this.selectedItemsMachine,
    product:this.selectedItemsPartno
    
  }
  // insert data
  this.httpservice.fetchpost('insertDataProcess.php', this.data, (cb) => {});
  this.getStartData();
  //upload image
  if (this.myFile != null) {
    this.uploadPhoto(this.myFile);
  }
  if (this.myFile_ != null) {
    this.uploadPhoto_(this.myFile_);
  }

  this.form.reset();
  this.selectedCtrl.reset();
  this.selectedProductCtrl.reset();
  this.controlCheck = false;
  this.selectedItemsPartno = [];
  this.selectedItemsMachine = [];
  this.arr_machine=[];
  this.picture = null;
}

getControlStatus($event){
if($event.checked == true){
  this.controlCheck = 1;
}else{
  this.controlCheck = 0
}
console.log('control point',this.controlPoint);

}
search(){ 
  clearInterval(this.setId);
  this.httpservice.fetchget('getJSON_process.php?key='+this.key,(process) => {
    this.rows = process;
    console.log('------this.processs------', this.processs);
  });
  this.ctrl.reset();
  this.key="";
  }

  ngOnInit() {
    this.form = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      name: [null, Validators.compose([Validators.required])],
      ct: [null, Validators.compose([Validators.required])],
      detail: [null, Validators.compose([Validators.required])],
      pictureInput: [null, Validators.compose([Validators.required])],
      fileInput : [null, Validators.compose([Validators.required])]
      //sorting:[null, Validators.compose([Validators.required])]
    });

  }

  attachFile(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc = reader.result;
      console.log(_self.imageSrc);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile.name);
   }

   attachFile_(event) : void {
    var reader = new FileReader();
    let _self = this;

    reader.onload = function(e) {
      _self.imageSrc_ = reader.result;
      console.log(_self.imageSrc_);
    };
    reader.readAsDataURL(event.target.files[0]);
    this.myFile_ = event.target.files[0];
   //this.uploadPhoto(event.target.files[0]);
   console.log('File name : ',this.myFile_.name);
   }


    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.tpn_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  uploadPhoto(file:File){
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi}`);
    request.send(formData);
  }
  uploadPhoto_(file:File){
    var formData = new FormData();
    formData.append('file', file);
    var request = new XMLHttpRequest();
    request.open('POST', `${this.urlApi_}`);
    request.send(formData);
  }

  openDeleteDialog(id:string) {

    let dialogRef = this.dialog.open(processDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
          this.delete(id);
        console.log('---result---',result,id);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    }); 
  }
  openEditDialog(){
    let dialogRef = this.dialog.open(processDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if( this.form.controls.name.value && this.form.controls.ct.value !=""){
          this.edit();
        }else{
          this.warningDialog('Please fill in Code, Name, CT Value !');
        }
      
       // console.log('---result---',result,this.user_selected.value.length,this.form.controls.code.value,this.form.controls.name.value,this.form.controls.ct.value);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openDialog() {
    let dialogRef = this.dialog.open(processDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if( this.form.controls.name.value && this.form.controls.ct.value !=""){
          this.save();
        }else{
          this.warningDialog('Please fill in Code, Name, CT Value!');
        }
      
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {
    let dialogRef = this.dialog.open(WarningProcessDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'process-dialog',
  templateUrl: 'dialog.html',
})
export class processDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<processDialog>) {}
}

//warning
@Component({
  selector: 'warning-process-dialog',
  templateUrl: 'warning.html',
})
export class WarningProcessDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningProcessDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/process/process.ts